import Cancel from '@mui/icons-material/Cancel';
import styled from '@emotion/styled';

// eslint-disable-next-line import/prefer-default-export
export const NoOption = styled(Cancel)`
  font-size: 1.2rem;
`;
